import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinerService } from '../services/spinner/spinner-service';

export const spinnerInterceptors: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const spinner = inject(SpinerService);
  // if (req.headers.has('X-Skip-Spinner')) {
  //   return next(req);
  // }
  spinner.show();
  return next(req).pipe(finalize(() => spinner.hide()));
};
